import { ComponentProps, ReactNode } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { DetailsItemsList } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import Attachments, { FileLike } from 'modules/inbox_tasks/components/Attachments'
import NoteField from 'modules/inbox_tasks/components/NoteField'

interface Props {
  details: ComponentProps<typeof DetailsItemsList>['details']
  files: FileLike[]
  additionalInformation?: string | null
  detailsContent?: ReactNode
}

const DetailsTab = ({ details, files, additionalInformation, detailsContent }: Props) => {
  return (
    <Box flexDirection="column" gap="s16">
      <Text.Header3>
        {i18n.t('tasks.approvals.contracts_contract_version.fields.request_details')}
      </Text.Header3>
      <DetailsItemsList details={details} tableView />
      {!!additionalInformation && (
        <NoteField
          label={i18n.t('procurement.purchase_requests.detail.info.description')}
          content={additionalInformation}
        />
      )}
      {!!files?.length && (
        <Box flexDirection="column" gap="s16">
          <Text.Header3>
            {i18n.t('procurement.purchase_requests.detail.tabs.attachments')}
          </Text.Header3>
          <Attachments files={files} />
        </Box>
      )}
      {detailsContent}
    </Box>
  )
}

export default DetailsTab
